import { createEvent, createStore } from 'effector';

type PendingAction = () => void;

interface UnsavedChangesDialogState {
  isOpen: boolean;
  pendingAction: PendingAction | null;
}

const initialState: UnsavedChangesDialogState = {
  isOpen: false,
  pendingAction: null,
};

export const requestUnsavedChangesConfirmation = createEvent<PendingAction>();
export const hideUnsavedChangesDialog = createEvent();

export const $unsavedChangesDialog = createStore<UnsavedChangesDialogState>(initialState)
  .on(requestUnsavedChangesConfirmation, (_, pendingAction) => ({
    isOpen: true,
    pendingAction,
  }))
  .reset(hideUnsavedChangesDialog);
